import { createClient } from "@supabase/supabase-js";

const supabaseURL = process.env.NEXT_PUBLIC_SUPABASE_URL || "";
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || "";
const supabaseServiceRoleKey =
  process.env.NEXT_PUBLIC_SUPABASE_SERVICE_ROLE_KEY || "";

// 읽기 전용 클라이언트 (anon 키 사용)
const supabaseAnon = createClient(supabaseURL, supabaseAnonKey, {
  auth: { persistSession: false },
});

// 쓰기 및 관리용 클라이언트 (service_role 키 사용)
const supabaseServiceRole = createClient(supabaseURL, supabaseServiceRoleKey, {
  auth: { persistSession: false },
});

export { supabaseAnon, supabaseServiceRole };
